import { AddMessage, MessageList } from "./chat";

export const MessageScreen = () => {
  return (
    <div className="flex-1">
      <div className="flex-1 p-[10px] pt-[30px] bg-[#ffffff] max-h-[calc(100vh-300px)] overflow-auto">
        <MessageList />
      </div>
      <AddMessage />
    </div>
  );
};
